import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdjustableSliderService {
  public slideIsReset$ = new BehaviorSubject(false);
}
